import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../../config/rbac/actions.ts";
import config from "./config";

export const CodePipelinesLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListCodePipelines} redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':name'
                element={
                    <RequirePermission action={rbacActions.GetCodePipeline} redirectTo={config.basePath}>
                        <EditPage/>
                    </RequirePermission>
                }

            >
            </Route>


        </Routes>
    );
};
